<template>

<section id="section-interest" class="section appear" data-stellar-background-ratio="0.4">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<p class="center-block notransition animated fadeInUpNow animation103 align-center" style="color:white;font-size: 45px;margin:0"><span>因 为 兴 趣</span><span style="margin-left:60px">所 以 热 爱</span></p>
					</div>
				</div>
			</div>
		</section>
</template>

<style>

</style>

<script>
export default {
  name: 'Interest'
}
</script>